import { useEffect } from 'react'
import { TrackEmarsysEvents } from './trackEvents'
import { useInitializeEmarsys } from './useInitializeEmarsys'
import { highlightBrowserLog } from '~/helpers/log'

export const variableName = 'WebEmarsysSdk'
export const ScarabQueue = 'ScarabQueue'

export const Emarsys = ({ ENV }: { ENV: Record<string, string> }) => {
  const EMARSYS_MERCHANT_ID = ENV?.EMARSYS_MERCHANT_ID as string
  const EMARSYS_MERCHANT_APPLICATION_CODE = ENV?.EMARSYS_MERCHANT_APPLICATION_CODE as string
  const EMARSYS_MERCHANT_SAFARI_WEBSITE_PUSH_ID = ENV?.EMARSYS_MERCHANT_SAFARI_WEBSITE_PUSH_ID as string
  const EMARSYS_MERCHANT_APPLICATION_SERVER_PUBLIC_KEY =
    ENV?.EMARSYS_MERCHANT_APPLICATION_SERVER_PUBLIC_KEY as string

  const source = ENV?.GTM_SOURCE

  const emarsysFired = useInitializeEmarsys(
    EMARSYS_MERCHANT_ID,
    EMARSYS_MERCHANT_APPLICATION_CODE,
    EMARSYS_MERCHANT_SAFARI_WEBSITE_PUSH_ID,
    EMARSYS_MERCHANT_APPLICATION_SERVER_PUBLIC_KEY,
  )

  useEffect(() => {
    window[variableName] = window[variableName] || []
    window.ScarabQueue = window.ScarabQueue || []
    TrackEmarsysEvents(
      (args: Record<any, any>) => {
        push({ ...args, source })
      },
      { variableName },
    )
  }, [])

  const push = (...args: any[]) => {
    window[variableName]?.push(args)
    try {
      highlightBrowserLog('Emarsys', args)
    } catch (e) {
      highlightBrowserLog('Emarsys', { erro: JSON.stringify(e) })
    }
  }

  return <>{/* Emarsys  mounted */}</>
}
